// 1. Remember to call initPagination() from the view you which inherits from this

// 2. Don't forget to put a container for the show more button with a 'show-more-items' class to your template
// or provide an alternative jQuery object as a parameter to initPagination()

// 3. If you need to provide additional data to the fetch request put it into a fetchData property
// on your collection and it will be picked up automatically when the 'show more' link is clicked

// 4. Remember that an 'add' event is triggered on your collection when additional elements are added
// and a 'reset' event is triggered on the first load. You will need to react on them differently
// in your view: append a last item of your collection on 'add' and .html() for rendering the whole list
// on 'reset'


define('lib/backbone/Backbone.PodioScrollPaginatedView',['require','translate','underscore','jquery','lib/backbone/Backbone.PodioView','lib/view_helpers/base','lib/Podio.Viewport'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var PodioView = require('lib/backbone/Backbone.PodioView');
  var viewHelpers = require('lib/view_helpers/base');
  var PodioViewport = require('lib/Podio.Viewport');

  var view = {
    initPagination: function (elmNavContainer, options) {
      _.bindAll(this, 'renderNav', 'removeNav', 'onShowMoreClick', 'hideSpinner', 'onWindowScroll');
      this.elmNavContainer = elmNavContainer || $('.show-more-items');
      this.elmNavContainer.delegate('a', 'click', this.onShowMoreClick);
      this.collection.bind('reset', this.renderNav);
      this.collection.bind('add', this.hideSpinner);
      this.collection.bind('noResultsLeft', this.removeNav);

      this.viewPortHelper = new PodioViewport();
      this.disableScrollTrigger = options && options.disableScrollTrigger;

      if (!this.disableScrollTrigger) {
        this.windowScrollHandler = _.throttle(this.onWindowScroll, 500);
        this.scrollTarget = (options && options.scrollTarget) || $(window);
        this.scrollTarget.on('scroll', this.windowScrollHandler);
      }
    },

    renderNav: function () {
      if (!this.collection.endReached && !this.elmNav) {
        this.elmNav = $(viewHelpers.link_to('#', t('Show more #scroll-pagination')));
        this.elmNavContainer.html(this.elmNav);
      }
    },

    removeNav: function() {
      if (this.elmNav) {
        this.elmNav.remove();
        delete this.elmNav;
      }
    },

    hideSpinner: function() {
      if (this.elmNav) {
        this.elmNav.removeClass('loading-overlay-small');
      }
    },

    onShowMoreClick: function() {
      this.elmNav.addClass('loading-overlay-small');
      this.collection.getNextPage({data: this.collection.fetchData});
      return false;
    },

    onWindowScroll: function() {
      if(!this.elmNav) {
        return;
      }

      if (this.shouldTriggerPagination()) {
        this.onShowMoreClick();
      }
    },

    shouldTriggerPagination: function() {
      return !this.elmNav.hasClass('loading-overlay-small') && this.viewPortHelper.getInfo(this.elmNavContainer).isInViewport;
    },

    unbindEvents: function() {
      this.elmNavContainer && this.elmNavContainer.undelegate('a', 'click');
      this.collection.unbind('reset', this.renderNav);
      this.collection.unbind('add', this.hideSpinner);
      this.collection.unbind('noResultsLeft', this.removeNav);

      if (!this.disableScrollTrigger) {
        this.scrollTarget && this.scrollTarget.off('scroll', this.windowScrollHandler);
      }
    }
  };

  return PodioView.extend(view, { mixin: view });

});

